import React from "react";

const MixPanelContext = React.createContext(() => {});

export const WithMixPanelEvents = Wrapped => props => (
  <MixPanelContext.Consumer>
    {mixPanelEvents => <Wrapped mixPanelEvents={mixPanelEvents} {...props} />}
  </MixPanelContext.Consumer>
);

export default MixPanelContext;
